import {connect} from 'react-redux';
import ReservationReview from './ReservationReview.jsx';
import {getCountInReviewCart} from '../../shared/util/getCountInCart';
import {
  handleReserveClick,
  handleContinueReservingClick
} from './actions';
import {displayClearCartConfirmation} from './actionTypes';

const mapStateToProps = state => ({
  cart: state.admin.review.cart,
  processing: state.admin.review.processing,
  total: state.admin.review.total,
  countInCart: getCountInReviewCart({
    squads: state.admin.review.cart ? state.admin.review.cart.squads : null,
    events: state.admin.review.cart ? state.admin.review.cart.events : null,
    virtualEvents: state.admin.review.cart ? state.admin.review.cart.virtualEvents : null
  })
});

const mapDispatchToProps = dispatch => ({
  onClearCartClick: () => dispatch(displayClearCartConfirmation(true)),
  onReserveClick: () => dispatch(handleReserveClick()),
  onContinueReservingClick: () => dispatch(handleContinueReservingClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(ReservationReview);



// WEBPACK FOOTER //
// ./src/features/admin/review/ReservationReviewContainer.jsx